import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { Box, Button, Menu, Slider, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useColors from "../../api/hooks/useColors";
import CustomToolTip from "../CustomTooltip";

const RangeSliderFilter = ({
  nameField,
  max,
  min,
  title,
  setAppliedFilters,
  step = 1,
  appliedFilters,
  ...props
}) => {
  // Initial state for range sliders with two values [min, max]
  const colors = useColors();
  const [anchorEl, setAnchorEl] = useState(null);
  const [valueRange, setValueRange] = useState([min, max]);
  useEffect(() => {
    setValueRange([min, max]);
  }, [max, min]);

  useEffect(() => {
    if (Object.keys(appliedFilters[nameField]).length === 0) {
      setValueRange([min, max]);
    }
  }, [appliedFilters, nameField]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleValueChange = (event, newValue) => {
    setValueRange(newValue);
    setAppliedFilters((prevFilters) => ({
      ...prevFilters,
      [nameField]: { min: valueRange[0], max: valueRange[1] },
    }));
  };

  return (
    <Box>
      <Button
        sx={{
          background: colors.grey_50,
          color:
            valueRange[0] !== min || valueRange[1] !== max
              ? colors.primary_dark
              : colors.text_primary,
          border:
            valueRange[0] !== min || valueRange[1] !== max
              ? "1px solid " + colors.primary_dark
              : "1px solid " + colors.grey_32percent,
          height: "32px",
          textTransform: "unset",
          borderRadius: "8px",
          fontSize: "12px",
          display: "flex",
        }}
        onClick={handleClick}
        endIcon={
          <KeyboardArrowDownRoundedIcon
            style={{ width: "20px", height: "20px" }}
          />
        }
      >
        <Typography variant="caption">{title}</Typography>
      </Button>
      {/* Menu that contains the range sliders */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: "260px",
            borderRadius: "8px",
            padding: "8px 15px",
            border: "1px solid " + colors.divider2,
            boxShadow: "0px 1px 4px 0px " + colors.black_10percent,
          },
        }}
      >
        {/* Likelihood Range Slider */}
        <Box>
          <Box>
            <Stack
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                justifyContent: "space-around",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <Box
                width={"100%"}
                display={"flex"}
                justifyContent={"space-around"}
                alignItems={"center"}
                gap={2}
              >
                <Typography variant="caption">{min}</Typography>
                <Slider
                  size="small"
                  value={valueRange}
                  onChange={handleValueChange}
                  min={min}
                  max={max}
                  step={step}
                  valueLabelDisplay="auto"
                  disableSwap
                  components={{
                    ValueLabel: ({ children, open, value }) => {
                      return (
                        <CustomToolTip
                          open={open}
                          title={
                            <Typography variant="caption"> {value}</Typography>
                          }
                          placement="top"
                        >
                          {children}
                        </CustomToolTip>
                      );
                    },
                  }}
                  sx={{
                    color: colors.primary_main,
                  }}
                />
                <Typography variant="caption">{max}</Typography>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Menu>
    </Box>
  );
};

export default RangeSliderFilter;
